import { SeatReclineNormalIcon } from './SeatReclineNormalIcon';

/**
 * author: Google
 * id B6642D7A-EE36-4C22-945E-88A218708CB6
 * name seat-recline-normal
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-recline-normal.svg
 * tags
 */
export const AirlineSeatReclineNormalIcon = SeatReclineNormalIcon;
export default AirlineSeatReclineNormalIcon